import { fetchBlob } from "~/shared/api/client";

// Browser-side file download via blob: works for cross-origin URLs because
// we fetch into a Blob first instead of relying on the `download` attribute
// (which honours `Content-Disposition` only for same-origin sources).
export async function downloadFromUrl(url: string, filename?: string): Promise<void> {
    const { blob } = await fetchBlob(url, { credentials: "omit" });
    const objectUrl = URL.createObjectURL(blob);
    try {
        const a = document.createElement("a");
        a.href = objectUrl;
        a.download = filename ?? deriveFilename(url) ?? "file";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}

function deriveFilename(url: string): string | null {
    try {
        const u = new URL(url, window.location.href);
        const segments = u.pathname.split("/").filter(Boolean);
        return segments[segments.length - 1] ?? null;
    } catch {
        return null;
    }
}
